import i18n from "../../i18n";
import { AUTOCOMPLETE_FIELD_TYPE, DATE_RANGE_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../helpers/constants";
import DateService from "../../services/dateService";

export const MY_OPEN_SURVEY_TABLE_NAME = "my_open_survey";
export const MY_CLOSED_SURVEY_TABLE_NAME = "my_closed_survey";

export const MY_OPEN_SURVEY_FILTER_PREFIX = "open";
export const MY_CLOSED_SURVEY_FILTER_PREFIX = "close";

export const MY_OPEN_SURVEY_TABLE_FIELDS_CONFIG = [
{
  name: "hrsurvey_date_expired",
  getValueCallback: (rowData) =>
    DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_expired),
  label: i18n.t("table.my_survey_table.hrsurvey_date_expired"),
  filterType: DATE_RANGE_FIELD_TYPE,
  getFilterFieldConfigCallback: (filteringData) => ({
      style: { maxWidth: "70px" },
    }),
  },
{
  name: "hrsurvey_name",
  getValueCallback: (rowData) => rowData.hrsurvey_name,
  label: i18n.t("table.my_survey_table.hrsurvey_name"),
  filterType: TEXT_FIELD_TYPE,
  getFilterFieldConfigCallback: (filteringData) => undefined,
},
{
  name: "my_role",
  getValueCallback: (rowData) => rowData.my_role,
  label: i18n.t("table.my_survey_table.role"),
  filterType: AUTOCOMPLETE_FIELD_TYPE,
  getFilterFieldConfigCallback: (filteringData) => ({
    options: filteringData?.value?.roles,
    isObjectOption: true,
    optionLabelKey: "hrrole_name",
    addNewValue: false,
    multiple: true,
    disableClearable: true,
    style: { minWidth: "100px" },
  }),
},
];

export const MY_CLOSED_SURVEY_TABLE_FIELDS_CONFIG = [
  {
    name: "my_survey_closed",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.my_survey_closed),
    label: i18n.t("table.my_survey_table.hrsurvey_date_close"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { maxWidth: "90px" },
    }),
  },
  {
    name: "hrsurvey_name",
    getValueCallback: (rowData) => rowData.hrsurvey_name,
    label: i18n.t("table.my_survey_table.hrsurvey_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "my_role",
    getValueCallback: (rowData) => rowData.my_role,
    label: i18n.t("table.my_survey_table.role"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.roles,
      isObjectOption: true,
      optionLabelKey: "hrrole_name",
      addNewValue: false,
      multiple: true,
      disableClearable: true,
      style: { minWidth: "100px" },
    }),
  },
];
